import { Component, ElementRef, OnInit, Inject } from '@angular/core';
import { UmsService } from '../ums.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-print-msg-box',
  templateUrl: './print-msg-box.component.html',
  styleUrls: ['./print-msg-box.component.scss']
})
export class PrintMsgBoxComponent implements OnInit {
  sessionList: any[];
  SessionFilterList: any[];
  SnNo: any;
  SessionForm: FormGroup;

  constructor( private elRef: ElementRef,
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    public router: Router,
    public dialogRef: MatDialogRef<PrintMsgBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    onClose() {
      this.dialogRef.close();
    }
  ngOnInit(): void {
    let the = localStorage.getItem('theme')
    this.SessionForm = this.fb.group({
      SessionId: new FormControl(''),
    });
    this.SnNo = parseInt(sessionStorage.getItem('session'))
    this.fetchSession()
  }

  fetchSession() {
    this.spinner.show();
    const payload = {};
    payload['SnDefault'] = '';
    payload['SnNo'] = ''; 
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
          this.SessionForm.controls['SessionId'].setValue(parseInt(sessionStorage.getItem('session')));
        this.SnNo = parseInt(sessionStorage.getItem('session'))
          
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.sessionList = [];
   })
  }

  onSelect(session){
    this.SnNo = session
  }

   onSessionSelected() {
    // Return the selected session object when closing the dialog
    // this.dialogRef.close(session);
    this.spinner.show();
    const payload = {};
    payload['RgNo'] = parseInt(sessionStorage.getItem('StudentRGID'))
    payload['SnNo'] = this.SnNo; 
    this.umsService.AllSnNoReports(payload).subscribe(res => {
      this.spinner.hide();
      
      if (res.status) {
       let mergedArray = []
        mergedArray = res.data.map(item => {
          return Object.assign({}, item, { SnNo: this.SnNo});
        });
        this.dialogRef.close(mergedArray);
      }
      else{
        let mergedArray = []
        mergedArray = mergedArray.map(item => {
          return Object.assign({}, item, { SnNo: this.SnNo});
        });
        this.dialogRef.close(mergedArray);
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.sessionList = [];
      let mergedArray = []
      mergedArray = mergedArray.map(item => {
        return Object.assign({}, item, { SnNo: this.SnNo});
      });
      this.dialogRef.close(mergedArray);
   })
  }

  redirect(to): void {
    // this.spinner.show()
    this.router.navigate([to]);
    //this.spinner.hide();
  }

  Close(){
    this.redirect('home');
    this.onClose()
  }

}


